import Repository from './Repository'

const URL_GET_SURVEY = '/survey'
const URL_COMPLETE_SURVEY = '/survey'

export default {
  getSurvey () {
    return Repository.get(URL_GET_SURVEY)
  },
  completeSurvey(data) {
    return Repository.post(URL_COMPLETE_SURVEY, data)
  }
}